import Icon from 'veui/components/Icon'

Icon.register({
  'file-disable': {
    paths: [
      {
        d: 'M512 256H256a32 32 0 010-64h256a32 32 0 010 64zM352 672H160V96h448v224a32 32 0 0064 0V64a32 32 0 00-32-32H128a32 32 0 00-32 32v640a32 32 0 0032 32h224a32 32 0 000-64zm-96-320a32 32 0 000 64h160a32 32 0 000-64zm480 224c0 88.22-71.78 160-160 160s-160-71.78-160-160 71.78-160 160-160 160 71.78 160 160zm-118.63 86.62l-128-128a96 96 0 00128 128zM672 576a96 96 0 00-137.37-86.62l128 128A95.47 95.47 0 00672 576z'
      }
    ],
    width: '768',
    height: '768'
  }
})
